import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_CITIES } from '../actionConstants';

export const getAllCitiesAction = createAction(GET_DICTIONARIES_CITIES);
